export const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const timespanRegex = /((?<Days>[0-9]*).)?(?<Hours>[0-9]{2}):(?<Minutes>[0-9]{2}):(?<Seconds>[0-9]{2})/;
